module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAJ9JREFUKBWdktENgCAMRNVvmcER3IGZWMCVWEQG4MMd9Fu8QwwQYxNpcrG299ImtOuKCCEoaIFWaE9izpoqrDlFQ0Mb9BXs6UwgYwE6v4iiTs8NI+F60qSCiym9asBAA03VCvIPvaYH7ZDMsvfVdQR3lMdXSy4cXLUpCPoG0hO0DaDlGzY9RxwG+P8BPGsmWDoE9vTjr75pbR60g8QjvwCR71tdS6mcAgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/team_me.png
// module id = zMSz
// module chunks = 1